<template>
    <div class="wrapper">
        <h4>{{ title }}</h4>
        <div v-if="note" class="note">Note: {{ note }}</div>
        <table
            cellspacing="1"
            cellpadding="7"
            border="1"
            :summary="summary"
            class="table table-bordered"
        >
            <tbody>
                <tr>
                    <th><div class="sr-only">No value</div></th>
                    <th
                        v-for="column in columnHeadings"
                        scope="col"
                        v-bind:key="column"
                    >
                        {{ column }}
                    </th>
                </tr>
                <template v-for="(row, rowIndex) in rows">
                    <tr v-if="row.title" class="row-title"
		                        v-bind:key="toKey('row1', rowIndex)">
                        <td :colspan="numberOfColumns">
                            <b>{{ row.suffix }}:</b>
                            {{ row.title }}
                        </td>
                    </tr>
                    <tr v-bind:key="toKey('row2', rowIndex)">
                        <td v-if="row.heading">{{ row.heading }}</td>
                        <td v-else>Number of Rows with Values</td>
                        <template v-for="(count, countIndex) in row.counts">
                            <td
                                v-if="count === null"
                            v-bind:key="toKey('row2', rowIndex, countIndex)"
                                style="background-color: darkgray"
                            ></td>
                            <td v-else v-bind:key="toKey('row', rowIndex, countIndex)">
                                {{ count }}
                            </td>
                        </template>
                    </tr>
                </template>
            </tbody>
        </table>
        <div v-if="footer" class="footer">{{ footer }}</div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off', space-in-parens: 'off' */

export default {
    props: [
        'title',
        'note',
        'columnHeadings',
        'rows',
        'rowAndColumnsTheSame',
        'footer'
    ],
    data: function () {
        var vm = this;
        return {
            summary:
                'This table representing missing data has ' +
                vm.columnHeadings.length +
                ' columns of ' +
                vm.columnHeadings.join(', '),
            numberOfColumns: vm.columnHeadings.length + 1
        };
    },
    methods: {
        toKey(item, i, j) {
            return item + '-' + i + (j ? j : '');
        }
    }
};
</script>

<style scoped>
div.column-title {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

table {
    margin-top: 10px;
    table-layout: fixed;
    width: auto;
    margin-bottom: 20px;
    font-size: 14px;
}

tr th:first-child {
    width: 210px;
}

tr th:not(:first-child) {
    background-color: #8eab6b;
    /* width: fit-content; */
    padding: 5px 10px 5px 10px;
    font-size: 14px;
}

th,
td {
    width: 120px;
}

.row-title {
    /* width: fit-content; */
    background-color: #c1d5b0;
    padding: 5px 10px 5px 10px;
    /* min-width: 200px; */
}

table,
th {
    border: none !important;
}
.wrapper {
    margin-bottom: 30px;
}

h4 {
    font-size: 18px;
    line-height: 28px;
    padding-top: 9px;
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 400;
    color: #000;
}

div.note {
    font-size: 14px;
}

.footer {
    font-size: 14px;
}
</style>
